
import axios from '@/utils/axiosHelper';

// 初始化数据(含授权)
export const onGetInitDataAPI = (params) => {
  return axios({ url: '/demon/diary/index', method: 'GET', params }, { interceptResultCode: false });
};

// 看日记任务
export const performTasksAPI = (data) => {
  return axios({ url: '/demon/diary/lottery', method: 'POST', data }, { interceptResultCode: false });
};

// 重新回答
export const retryAPI = (data) => {
  return axios({ url: '/demon/diary/retry', method: 'POST', data }, { interceptResultCode: false });
};

// 领取每日奖励
export const receiveDailyRewardsAPI = (data) => {
  return axios({ url: '/demon/diary/reward', method: 'POST', data }, { interceptResultCode: false });
};

// 更新日记领取状态
export const lotteryUpdateAPI = (data) => {
  return axios({ url: '/demon/diary/lottery/update', method: 'POST', data }, { interceptResultCode: false });
};

// 帮助页面初始化数据(含授权)
export const onHelpGetInitDataAPI = (params) => {
  return axios({ url: '/demon/diary/help', method: 'GET', params }, { interceptResultCode: false });
};

// 助力
export const onHelpAPI = (data) => {
  return axios({ url: '/demon/diary/help', method: 'POST', data }, { interceptResultCode: false });
};



// WEBPACK FOOTER //
// ./src/pages/servitor/nmrj/api.js